export default __webpack_public_path__ + "4b65ebf8551bdceb25ffb68109d911ea.png";